/**
 * 商户结算统计
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      class="user-search"
      :rules="rules"
      ref="formRef"
    >
      <el-form-item label="商户类型:">
        <el-select
          size="small"
          v-model="formInline.agentType"
          placeholder="全部"
        >
          <el-option
            v-for="(val, index) in merchantTypeList"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户:">
        <el-select
          size="small"
          v-model="formInline.merchantName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入商户名称"
          @blur="selectMerchantNameBlur"
        >
          <el-option
            v-for="(val, index) in merchantList"
            :label="val"
            :value="val"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务商:">
        <el-select
          size="small"
          v-model="formInline.disCompanyName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入服务商名称"
          @blur="selectDisCompanyBlur"
        >
          <el-option
            v-for="(val, index) in disCompanyList"
            :label="val.label"
            :value="val.label"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围: " prop="date">
        <el-date-picker
          size="small"
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          :required="true"
          :placeholder="`请选择时间范围，默认查当前月`"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset">清空</el-button>
      </el-form-item>
    </el-form>

    <div style="margin-bottom: 10px">
      <el-button type="primary" size="small" @click="exportdata"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->

      <el-table-column
        fixed
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        fixed
        prop="totalNumberTransactions"
        label="总笔数"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column prop="serviceFee" label="总服务费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{
            scope.row.serviceFee ? scope.row.serviceFee.toFixed(2) : 0
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="settlementTime"
        label="结算时间"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-popover placement="right" width="320" trigger="click">
            <!-- 加载状态 -->
            <div v-if="loadingActivities" class="loading-container">
              <i class="el-icon-loading"></i>
              <div class="loading-text">加载中...</div>
            </div>

            <!-- 数据内容 -->
            <div v-else class="timeline-container">
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  v-for="(activity, index) in activities"
                  :key="index"
                  :timestamp="activity.timestamp"
                  :type="activity.type"
                >
                  {{ activity.content }}
                </el-timeline-item>
              </el-timeline>
            </div>
            <span
              class="view-text"
              slot="reference"
              @click="fetchDisTimeLog(scope.row)"
            >
              查看
            </span>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div style="background-color: #fff; padding: 15px; margin: 20px auto">
      <el-row :gutter="20">
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总笔数：</span
              ><span>{{ currentPageSummary.totalNum }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总服务费：</span
              ><span>{{ formatNumber(currentPageSummary.totalService) }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
  </div>
</template>

<script>
import {
  getSalesMerchantSettlementTime,
  getMerchantStatistical,
  getSalesMerchantName,
  getDisCompanyNames,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loadingActivities: false,
      reverse: false,
      activities: [],
      infos: {
        totalService: 0,
        totalNum: 0,
      },
      merchantList: [],
      disCompanyList: [],
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载

      // rules表单验证
      rules: {
        date: [
          { required: true, message: "请选择时间范围", trigger: "change" }, // 时间范围必输校验
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: this.getDefaultMonthRange(),
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */
  computed: {
    currentPageSummary() {
      // 计算总和（处理 null/undefined 的情况）
      const summary = this.listData.reduce(
        (acc, item) => {
          acc.totalNum += Number(item.totalNumberTransactions) || 0;
          acc.totalService += Number(item.serviceFee) || 0;
          return acc;
        },
        { totalNum: 0, totalService: 0 }
      );

      this.infos = summary;
      return this.infos;
    },
  },
  /**
   * 创建完毕
   */
  created() {
    getSalesMerchantName({
      page: 1,
      pageSize: 9999,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.merchantList = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    // 服务商
    getDisCompanyNames({
      page: 1,
      pageSize: 9999,
      type: 2,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.disCompanyList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    this.getdata(this.formInline);
  },

  watch: {
    "formInline.agentType": function (newVal) {
      let params = {
        agentType: newVal,
      };

      getSalesMerchantName(params)
        .then((res) => {
          if (res.msg == "success") {
            this.merchantList = res.data.items;
            this.formInline.merchantName = "";
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        agentType: "",
        date: this.getDefaultMonthRange(),
      };
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(formInline) {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }

      let params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
        merchantName: formInline.merchantName,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
      };
      getMerchantStatistical(params)
        .then((res) => {
          if (res.msg == "success") {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    getAgentTypeLabel(agentType) {
      const type = this.merchantTypeList.find(
        (item) => item.value === agentType
      );
      return type ? type.label : "未知";
    },
    exportdata() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }

      // 默认导出99999
      let params = {
        page: 1,
        pageSize: 99999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        agentType: this.formInline.agentType,
        export: 1,
      };
      getMerchantStatistical(params)
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },

    selectMerchantNameBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    selectDisCompanyBlur(e) {
      this.formInline.disCompanyName = e.target.value;
    },
    fetchDisTimeLog(row) {
      this.loadingActivities = true;
      this.activities = []; // 清空旧数据

      let params = {
        page: 1,
        pageSize: 99999,
        merchantName: row.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
      };

      getSalesMerchantSettlementTime(params)
        .then((res) => {
          if (res.msg === "success") {
            if (res.data.length == 0) {
              this.activities = [
                {
                  content: "暂无结算记录",
                  timestamp: "",
                  type: "danger",
                },
              ];
              return;
            }

            // 格式化时间线数据
            const activities = res.data.map((item) => {
              // 根据status映射type
              let type;
              switch (item.status) {
                case 4:
                  type = "success";
                  break;
                case 5:
                  type = "warning";
                  break;
                default:
                  type = "danger";
              }

              // 格式化时间：优先使用settlementAtStr，否则使用createAtTime
              let timestamp;
              if (item.settlementAtStr) {
                timestamp = item.settlementAtStr;
              } else if (item.createdAtTime) {
                // 将时间戳转换为yyyy-MM-dd格式
                const date = new Date(item.createdAtTime * 1000);
                timestamp = `${date.getFullYear()}-${
                  (date.getMonth() + 1).toString().padStart(2, "0") // 月份补零
                }-${
                  date.getDate().toString().padStart(2, "0") // 日期补零
                }`;
              } else {
                timestamp = "无时间信息"; // 兜底处理
              }

              return {
                content:
                  "批次：" +
                  item.batchNumber +
                  "，" +
                  (item.statusStr || "未知状态"),
                timestamp,
                type,
              };
            });

            this.activities = activities;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
            // 错误状态
            this.activities = [
              {
                content: "加载失败：" + res.msg,
                timestamp: "",
                type: "danger",
              },
            ];
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: "获取结算记录失败",
          });
          // 错误状态
          this.activities = [
            {
              content: "加载失败：网络错误",
              timestamp: "",
              type: "danger",
            },
          ];
        })
        .finally(() => {
          // 隐藏加载状态
          this.loadingActivities = false;
        });
    },
    getDefaultMonthRange() {
      const now = new Date(); // 当前日期（包含时分秒）
      const start = new Date(now.getFullYear(), now.getMonth(), 1); // 当月1号（00:00:00）

      // 当天日期：保留年月日，时分秒置为0（可选，根据需求决定是否需要精确到天）
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // 当天日期（00:00:00）
      // 或直接使用原始时间（包含当前时分秒）：const end = new Date(now);

      // 格式化函数（本地时间，YYYY-MM-DD）
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      return [formatDate(start), formatDate(end)]; // 返回格式化后的日期数组
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.view-text {
  color: #409eff; /* Element UI 按钮默认颜色 */
  cursor: pointer; /* 鼠标指针样式 */
  text-decoration: none;
  display: inline-block;
  padding: 0 3px;
  line-height: 1;
}

.view-text:hover {
  color: #66b1ff; /* Element UI 按钮悬停颜色 */
  text-decoration: underline;
}
.timeline-container {
  max-height: 500px; /* 设置最大高度 */
  overflow-y: auto; /* 超出高度时显示垂直滚动条 */
  padding-right: 5px; /* 为滚动条留出空间 */
}

/* 自定义滚动条样式 */
.timeline-container::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

.timeline-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道背景 */
  border-radius: 3px;
}

.timeline-container::-webkit-scrollbar-thumb {
  background: #c1c1c1; /* 滚动条滑块颜色 */
  border-radius: 3px;
}

.timeline-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; /* 鼠标悬停时滑块颜色 */
}
/* 添加样式 */
.loading-container {
  padding: 30px 10px;
  text-align: center;
}

.loading-text {
  margin-top: 8px;
  color: #606266;
}
</style>

 


// WEBPACK FOOTER //
// src/views/sales/salesMerchantStatistics.vue